/* The Copper Bottle — storefront behaviour
   Countdown bar, menu drawer, benefits switcher, review carousel,
   copper-vs-steel comparison slider, flip cards, image rotator, gallery,
   bundle pricing and a cart drawer (localStorage demo cart, Shopify-ready). */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var SHOPIFY = !!(window.CBTHEME && window.CBTHEME.shopifyCart);

  /* ---------- Countdown bar (resets at local midnight) ---------- */
  var tHrs = $('#tHrs'), tMins = $('#tMins'), tSecs = $('#tSecs');
  function pad(n) { return String(n).padStart(2, '0'); }
  function tickCountdown() {
    if (!tHrs) return;
    var now = new Date();
    var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    var diff = Math.max(0, Math.floor((end - now) / 1000));
    tHrs.textContent = pad(Math.floor(diff / 3600));
    tMins.textContent = pad(Math.floor((diff % 3600) / 60));
    tSecs.textContent = pad(diff % 60);
  }
  tickCountdown();
  setInterval(tickCountdown, 1000);


  /* ---------- Transparent header over the video hero ---------- */
  var overlayHeader = $('.site-header--overlay'), videoHero = $('.hero--video');
  if (overlayHeader && videoHero) {
    var setHeaderHeight = function () {
      document.documentElement.style.setProperty('--header-h', overlayHeader.offsetHeight + 'px');
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
    videoHero.classList.add('is-under-header');
  }

  /* ---------- Video hero: pick the portrait or landscape encode ---------- */
  var heroVideo = $('#heroVideoEl');
  if (heroVideo) {
    var pickHeroSource = function () {
      var portrait = window.matchMedia('(orientation: portrait)').matches;
      var src = heroVideo.getAttribute(portrait ? 'data-portrait' : 'data-landscape');
      var poster = heroVideo.getAttribute(portrait ? 'data-portrait-poster' : 'data-landscape-poster');
      if (src && heroVideo.getAttribute('src') !== src) {
        heroVideo.setAttribute('poster', poster);
        heroVideo.setAttribute('src', src);
        heroVideo.load();
        var playing = heroVideo.play();
        if (playing && playing.catch) playing.catch(function () {});
      }
    };
    pickHeroSource();
    window.matchMedia('(orientation: portrait)').addEventListener('change', pickHeroSource);
  }

  /* ---------- Menu drawer ---------- */
  var navToggle = $('#navToggle'), menuDrawer = $('#menuDrawer');
  if (navToggle && menuDrawer) {
    navToggle.addEventListener('click', function () {
      var header = $('.site-header');
      if (header) document.documentElement.style.setProperty('--header-h', header.getBoundingClientRect().bottom + 'px');
      var open = menuDrawer.classList.toggle('is-open');
      navToggle.classList.toggle('is-open', open);
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* ---------- Smooth-scroll anchors (also close the drawer) ---------- */
  $$('.js-scroll, .menu-drawer a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href') || '';
      var hash = href.indexOf('#') === 0 ? href : null;
      if (!hash) return;
      var target = $(hash);
      if (!target) return;
      e.preventDefault();
      if (menuDrawer) menuDrawer.classList.remove('is-open');
      if (navToggle) { navToggle.classList.remove('is-open'); navToggle.setAttribute('aria-expanded', 'false'); }
      document.body.style.overflow = '';
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- Benefits list → image switcher ---------- */
  var benefitsImage = $('#benefitsImage');
  $$('#benefitsList .benefit-row').forEach(function (row) {
    row.addEventListener('click', function () {
      $$('#benefitsList .benefit-row').forEach(function (r) { r.classList.remove('is-active'); });
      row.classList.add('is-active');
      var img = row.getAttribute('data-image');
      if (benefitsImage && img) {
        benefitsImage.src = img;
        benefitsImage.alt = row.querySelector('.benefit-row__head').textContent.trim();
      }
    });
  });

  /* ---------- Review carousel ---------- */
  var reviewTrack = $('#reviewTrack');
  function carouselStep() {
    if (!reviewTrack) return 0;
    var card = reviewTrack.querySelector('.review-card');
    return card ? card.getBoundingClientRect().width + 18 : 0;
  }
  if ($('#revPrev')) $('#revPrev').addEventListener('click', function () { reviewTrack && reviewTrack.scrollBy({ left: -carouselStep(), behavior: 'smooth' }); });
  if ($('#revNext')) $('#revNext').addEventListener('click', function () { reviewTrack && reviewTrack.scrollBy({ left: carouselStep(), behavior: 'smooth' }); });

  /* ---------- Copper vs Steel comparison slider ----------
     Steel panel is clipped to the left of --pos; copper shows on the right. */
  var baSlider = $('#baSlider'), baRange = $('#baRange');
  if (baSlider && baRange) {
    var baSetPos = function (pct) {
      pct = Math.max(0, Math.min(100, pct));
      baSlider.style.setProperty('--pos', pct + '%');
      baRange.value = pct;
    };
    var baPosFromEvent = function (e) {
      var rect = baSlider.getBoundingClientRect();
      return ((e.clientX - rect.left) / rect.width) * 100;
    };
    var baDragging = false;
    baSlider.addEventListener('pointerdown', function (e) {
      baDragging = true;
      baSlider.classList.add('is-dragging');
      if (baSlider.setPointerCapture) { try { baSlider.setPointerCapture(e.pointerId); } catch (err) {} }
      baSetPos(baPosFromEvent(e));
      e.preventDefault();
    });
    baSlider.addEventListener('pointermove', function (e) { if (baDragging) baSetPos(baPosFromEvent(e)); });
    var baStop = function () { baDragging = false; baSlider.classList.remove('is-dragging'); };
    baSlider.addEventListener('pointerup', baStop);
    baSlider.addEventListener('pointercancel', baStop);
    baRange.addEventListener('input', function () { baSlider.style.setProperty('--pos', baRange.value + '%'); });
    baSetPos(parseFloat(baRange.value));
  }

  /* ---------- Flip cards ---------- */
  $$('.flip-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var flipped = card.classList.toggle('is-flipped');
      card.setAttribute('aria-pressed', flipped ? 'true' : 'false');
    });
  });

  /* ---------- Image rotator ---------- */
  $$('.js-rotator').forEach(function (rot) {
    var imgs = rot.querySelectorAll('img');
    if (imgs.length < 2) return;
    var current = 0;
    setInterval(function () {
      imgs[current].classList.remove('is-active');
      current = (current + 1) % imgs.length;
      imgs[current].classList.add('is-active');
    }, 4200);
  });

  /* ---------- Product gallery ---------- */
  var galleryMain = $('#galleryMain');
  $$('#galleryThumbs .thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      $$('#galleryThumbs .thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (galleryMain) galleryMain.src = thumb.getAttribute('data-src');
    });
  });

  /* ---------- Arrival date ---------- */
  var arrival = $('#arrivalDate');
  if (arrival) {
    var d = new Date();
    d.setDate(d.getDate() + 5);
    arrival.textContent = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  }

  /* ---------- Bundle + purchase-type pricing ---------- */
  var atcPrice = $('#atcPrice'), atcCompare = $('#atcCompare'), stickyPrice = $('#stickyPrice');
  var purchaseToggle = $('#purchaseToggle');
  var SUBSCRIBE_DISCOUNT = purchaseToggle ? (parseFloat(purchaseToggle.getAttribute('data-discount')) || 0) / 100 : 0.25;
  var MONEY_FORMAT = (window.CBTHEME && window.CBTHEME.moneyFormat) || '${{amount}}';
  /* n is a decimal amount (e.g. 29.95). Handles Shopify's {{amount}} placeholders. */
  function money(n) {
    var fixed = n.toFixed(2), whole = Math.round(n).toString();
    return MONEY_FORMAT
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fixed.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, fixed.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' '))
      .replace(/\{\{\s*amount\s*\}\}/g, fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function isSubscribe() {
    var input = $('#purchaseToggle input[name=ptype]:checked');
    return !!(input && input.value === 'subscribe');
  }
  function selectedBundle() {
    var input = $('#bundles input:checked');
    if (!input) return null;
    var divisor = SHOPIFY ? 100 : 1;
    var base = parseFloat(input.getAttribute('data-price')) / divisor;
    var price = isSubscribe() ? base * (1 - SUBSCRIBE_DISCOUNT) : base;
    return {
      id: input.value + (isSubscribe() ? '-sub' : ''),
      variantId: input.getAttribute('data-variant-id'),
      title: input.getAttribute('data-title') + (isSubscribe() ? ' (Subscription)' : ''),
      price: Math.round(price * 100) / 100,
      compare: parseFloat(input.getAttribute('data-compare')) / divisor,
      qty: parseInt(input.getAttribute('data-qty'), 10)
    };
  }
  function refreshOfferPrice() {
    var b = selectedBundle();
    if (!b) return;
    if (atcPrice) atcPrice.textContent = money(b.price);
    if (atcCompare) atcCompare.textContent = b.compare > b.price ? money(b.compare) : '';
    if (stickyPrice) stickyPrice.textContent = money(b.price);
  }
  $$('#bundles input, #purchaseToggle input').forEach(function (input) { input.addEventListener('change', refreshOfferPrice); });
  refreshOfferPrice();

  /* ---------- Cart drawer ---------- */
  var cartDrawer = $('#cartDrawer'), cartOverlay = $('#cartOverlay'), cartItemsEl = $('#cartItems');
  var cartEmptyEl = $('#cartEmpty'), cartFoot = $('#cartFoot'), cartTotalEl = $('#cartTotal'), cartCountEl = $('#cartCount');
  var cartDiscountsEl = $('#cartDiscounts'), cartTotalWasEl = $('#cartTotalWas');

  /* Discount titles come from the Shopify admin, so escape before using innerHTML. */
  function escHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function openCart() {
    if (!cartDrawer) return;
    cartOverlay.hidden = false;
    requestAnimationFrame(function () { cartOverlay.classList.add('is-open'); cartDrawer.classList.add('is-open'); });
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartOverlay.classList.remove('is-open');
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { cartOverlay.hidden = true; }, 280);
  }
  if ($('#cartOpen')) $('#cartOpen').addEventListener('click', function () { if (SHOPIFY) refreshShopifyCart(); openCart(); });
  if ($('#cartClose')) $('#cartClose').addEventListener('click', closeCart);
  if ($('#continueShopping')) $('#continueShopping').addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* Shopify cart (used when CBTHEME.shopifyCart is true) */
  function renderShopifyCart(cart) {
    if (!cartItemsEl) return;
    cartItemsEl.innerHTML = '';
    var discountTotals = {}, discountOrder = [];
    cart.items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'cart-item';
      var unitNote = item.quantity > 1 ? ' <small>(' + item.quantity + ' × ' + money(item.final_price / 100) + ')</small>' : '';
      /* Show what the shopper saved, and why, rather than a silently lower price. */
      var savedHtml = '';
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        var title = (alloc.discount_application && alloc.discount_application.title) || 'Discount';
        if (!(title in discountTotals)) discountOrder.push(title);
        discountTotals[title] = (discountTotals[title] || 0) + alloc.amount;
        savedHtml += '<span class="cart-item__discount">' + escHtml(title) + ' −' + money(alloc.amount / 100) + '</span>';
      });
      var wasHtml = item.original_line_price > item.final_line_price
        ? '<s class="cart-item__was">' + money(item.original_line_price / 100) + '</s> '
        : '';
      li.innerHTML = (item.image ? '<img src="' + item.image + (item.image.indexOf('?') >= 0 ? '&' : '?') + 'width=120" alt="">' : '') +
        '<div class="cart-item__info"><b></b><span>' + wasHtml + money(item.final_line_price / 100) + unitNote + '</span>' + savedHtml +
        '<div class="cart-item__qty"><button data-key="' + item.key + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button data-key="' + item.key + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
        '<button class="cart-item__remove" data-key="' + item.key + '" data-q="0">Remove</button>';
      li.querySelector('b').textContent = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' – ' + item.variant_title : '');
      cartItemsEl.appendChild(li);
    });
    (cart.cart_level_discount_applications || []).forEach(function (app) {
      var title = app.title || 'Discount';
      if (!(title in discountTotals)) discountOrder.push(title);
      discountTotals[title] = (discountTotals[title] || 0) + (app.total_allocated_amount || 0);
    });
    if (cartDiscountsEl) {
      var rows = discountOrder.filter(function (title) { return discountTotals[title] > 0; }).map(function (title) {
        return '<li><span>' + escHtml(title) + '</span><b>−' + money(discountTotals[title] / 100) + '</b></li>';
      });
      cartDiscountsEl.innerHTML = rows.join('');
      cartDiscountsEl.hidden = !rows.length;
    }
    if (cartTotalWasEl) {
      var showWas = cart.original_total_price > cart.total_price;
      cartTotalWasEl.textContent = showWas ? money(cart.original_total_price / 100) : '';
      cartTotalWasEl.hidden = !showWas;
    }
    if (cartEmptyEl) cartEmptyEl.style.display = cart.item_count ? 'none' : '';
    if (cartFoot) cartFoot.hidden = !cart.item_count;
    if (cartTotalEl) cartTotalEl.textContent = money(cart.total_price / 100);
    if (cartCountEl) cartCountEl.textContent = cart.item_count;
  }
  function refreshShopifyCart() { fetch('/cart.js').then(function (r) { return r.json(); }).then(renderShopifyCart); }
  function shopifyAdd(variantId, qty, sellingPlan) {
    var payload = { id: variantId, quantity: qty };
    if (sellingPlan) payload.selling_plan = sellingPlan;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return refreshShopifyCart(); });
  }
  function shopifyChange(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderShopifyCart);
  }

  /* Demo cart (localStorage) — used until the store is connected to a checkout */
  var CART_KEY = 'copperbottle_cart';
  function loadCart() { try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch (e) { return []; } }
  function saveCart(cart) { try { localStorage.setItem(CART_KEY, JSON.stringify(cart)); } catch (e) {} }
  function renderDemoCart() {
    var cart = loadCart();
    if (!cartItemsEl) return;
    cartItemsEl.innerHTML = '';
    var total = 0, count = 0;
    cart.forEach(function (item, i) {
      total += item.price * item.qty;
      count += item.qty;
      var li = document.createElement('li');
      li.className = 'cart-item';
      li.innerHTML = '<img src="assets/product-1-thumb.webp" alt=""><div class="cart-item__info"><b></b><span>' + money(item.price * item.qty) + '</span>' +
        '<div class="cart-item__qty"><button data-i="' + i + '" data-d="-1" aria-label="Decrease quantity">−</button><span>' + item.qty + '</span><button data-i="' + i + '" data-d="1" aria-label="Increase quantity">+</button></div></div>' +
        '<button class="cart-item__remove" data-remove="' + i + '">Remove</button>';
      li.querySelector('b').textContent = item.title;
      cartItemsEl.appendChild(li);
    });
    if (cartEmptyEl) cartEmptyEl.style.display = cart.length ? 'none' : '';
    if (cartFoot) cartFoot.hidden = !cart.length;
    if (cartTotalEl) cartTotalEl.textContent = money(total);
    if (cartCountEl) cartCountEl.textContent = count;
  }

  if (cartItemsEl) {
    cartItemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      if (SHOPIFY) {
        if (btn.hasAttribute('data-key')) shopifyChange(btn.getAttribute('data-key'), Math.max(0, parseInt(btn.getAttribute('data-q'), 10)));
        return;
      }
      var cart = loadCart();
      if (btn.hasAttribute('data-remove')) {
        cart.splice(parseInt(btn.getAttribute('data-remove'), 10), 1);
      } else if (btn.hasAttribute('data-i')) {
        var i = parseInt(btn.getAttribute('data-i'), 10), d2 = parseInt(btn.getAttribute('data-d'), 10);
        cart[i].qty = Math.max(1, cart[i].qty + d2);
      }
      saveCart(cart);
      renderDemoCart();
    });
  }

  var addToCartBtn = $('#addToCart');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function () {
      var b = selectedBundle();
      if (!b) return;
      if (SHOPIFY) {
        var bundlesEl = $('#bundles');
        var variantId = b.variantId || (bundlesEl && bundlesEl.getAttribute('data-variant-id'));
        var sellingPlan = isSubscribe() && bundlesEl ? bundlesEl.getAttribute('data-selling-plan') : null;
        if (variantId) {
          addToCartBtn.disabled = true;
          shopifyAdd(parseInt(variantId, 10), b.qty, sellingPlan).then(openCart).catch(function () { addToCartBtn.textContent = 'Could not add to cart'; })
            .then(function () { addToCartBtn.disabled = false; });
        } else {
          addToCartBtn.textContent = 'Select a product in the theme editor';
          setTimeout(function () {
            addToCartBtn.innerHTML = 'Add To Cart - <span id="atcPrice"></span> <s id="atcCompare"></s>';
            atcPrice = $('#atcPrice'); atcCompare = $('#atcCompare');
            refreshOfferPrice();
          }, 2500);
        }
        return;
      }
      var cart = loadCart();
      var existing = cart.find(function (item) { return item.id === b.id; });
      if (existing) existing.qty += 1; else cart.push({ id: b.id, title: b.title, price: b.price, qty: 1 });
      saveCart(cart);
      renderDemoCart();
      openCart();
    });
  }

  var checkoutBtn = $('#checkoutBtn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      if (SHOPIFY) { window.location.href = (window.CBTHEME && window.CBTHEME.checkoutUrl) || '/checkout'; return; }
      checkoutBtn.textContent = 'Connect a checkout to go live';
      setTimeout(function () { checkoutBtn.textContent = 'Checkout'; }, 2200);
    });
  }

  if (SHOPIFY) refreshShopifyCart(); else renderDemoCart();

  /* ---------- Advertorial: story quote carousel ---------- */
  var lpQuotes = $('#lpQuotes');
  if (lpQuotes) {
    var quotes = $$('.lp-quote', lpQuotes), dotsWrap = $('[data-quote-dots]', lpQuotes), current = 0;
    var showQuote = function (i) {
      current = (i + quotes.length) % quotes.length;
      quotes.forEach(function (q, n) { q.classList.toggle('is-active', n === current); });
      $$('button', dotsWrap).forEach(function (d, n) { d.classList.toggle('is-active', n === current); });
    };
    if (dotsWrap) quotes.forEach(function (q, n) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Show quote ' + (n + 1));
      dot.addEventListener('click', function () { showQuote(n); });
      dotsWrap.appendChild(dot);
    });
    var prev = $('[data-quote-prev]', lpQuotes), next = $('[data-quote-next]', lpQuotes);
    if (prev) prev.addEventListener('click', function () { showQuote(current - 1); });
    if (next) next.addEventListener('click', function () { showQuote(current + 1); });
    showQuote(0);
  }

  /* ---------- Newsletter (demo) ---------- */
  var newsletterForm = $('#newsletterForm');
  if (newsletterForm && !SHOPIFY) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      newsletterForm.classList.add('is-hidden');
      var thanks = $('#newsletterThanks');
      if (thanks) thanks.classList.remove('is-hidden');
    });
  }
})();
